import React, { useEffect, useState } from 'react'
import { IoMdSearch } from 'react-icons/io'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { RadioButton, SkyButton } from '../../Components/Buttons'
import Select from '../../Components/Autocompelte/Select'
import CustomInput from '../../Components/Input/CustomInput'
import { getDecryptedSessionStorageVariable } from '../../utils/encryptStorage'
import DatePicker2 from '../../Components/Input/DatePicker2'
import { toast } from 'react-toastify'

export default function CabBookingHistory() {
  const fleetId = getDecryptedSessionStorageVariable('fleetId')
  const [searchBy, setSearchBy] = useState('date')
  const [bookingId, setBookingId] = useState('')
  const [fromDate, setFromDate] = useState('')
  const [toDate, setToDate] = useState('')
  const [status, setStatus] = useState('')
  const [customerMobileNumber, setCustomerMobileNumber] = useState('')
  const [selectedFleet, setSelectedFleet] = useState(null)
  const [driverMobileNumber, setDriverMobileNumber] = useState('')
  const [paymentMode, setPaymentMode] = useState('')
  const [tripType, settTripType] = useState('')
  const [selectedCustomer, setSelectCustomer] = useState(null)
  const navigate = useNavigate()

  const [searchParams] = useSearchParams()
  const searchByBookingId = searchParams.get('searchByHeader')

  const obj = {
    fromDate: new Date(fromDate),
    toDate: new Date(toDate),
    status: status?.value ?? '',
    tripType: tripType?.value ?? '',
    fleetOwnerId: fleetId,
  }

  const handleNavigate = () => {
    if (bookingId !== '') {
      navigate(`/search-cab-booking?searchBy=bookingId&bookingId=${bookingId}`)
    } else {
      if (fromDate === '' || toDate === '') {
        toast.warn('Please select from date and to date')
        return
      }
      navigate(`/search-cab-booking?searchBy=bookingDate`, {
        state: obj,
      })
    }
  }
  useEffect(() => {
    if (searchByBookingId === 'headerBookingId') {
      setSearchBy('booking')
    } else {
      setSearchBy('date')
    }
  }, [searchByBookingId])

  useEffect(() => {
    setCustomerMobileNumber(selectedCustomer?.id)
  }, [selectedCustomer])

  useEffect(() => {
    setDriverMobileNumber(selectedFleet?._id)
  }, [selectedFleet])
  return (
    <div className="w-full  h-full bg-white p-4 shadow rounded-md">
      <div className="w-full flex justify-between">
        <div className="text-stone-500 text-xl font-bold">
          Search Cab Booking
        </div>
      </div>

      {/* <div className="mt-4 pl-1 flex gap-3 flex-col text-start md:flex md:flex-row">
        <div className="text-stone-500 text-sm font-normal font-['Segoe UI']">
          Search By
        </div>
        <div>
          <div className="flex gap-2">
            <RadioButton
              label="Search By date"
              checked={searchBy === 'date'}
              onChange={() => setSearchBy('date')}
            />
            <RadioButton
              label="Search By BookingId"
              checked={searchBy === 'booking'}
              onChange={() => setSearchBy('booking')}
            />
          </div>
        </div>
      </div> */}
      {searchBy === 'date' ? (
        <div>
          <div className="mt-5 ">
            <div className="flex flex-col gap-3 md:flex md:flex-row md:gap-10">
              <DatePicker2
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
                //   placeholderValue={'From Date'}
                labelValue={'From Date'}
              />
              <DatePicker2
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
                // placeholderValue={'To Date'}
                labelValue={'To Date'}
              />
            </div>
          </div>
          <div className="mt-5 md:mt-10">
            <div className="flex flex-col gap-3 md:flex md:gap-10 md:flex-row">
              <Select
                selected={status}
                onSelect={setStatus}
                placeholderValue={'Select Status'}
                labelValue={' Select Status'}
                options={[
                  { value: '', label: 'Select Status' },
                  { value: 'New Booking', label: 'New Booking' },
                  { value: 'Line Up', label: 'InLine' },
                  { value: 'Start Duty', label: 'OnDuty' },
                  { value: 'Off Duty', label: 'Done' },
                  { value: 'Paid', label: 'Paid' },
                  { value: 'Cancelled', label: 'Cancelled' },
                ]}
              />
              <Select
                selected={tripType}
                onSelect={settTripType}
                placeholderValue={'Select Trip Type'}
                labelValue={'Select Trip Type'}
                options={[
                  { value: '', label: 'Select Trip Type' },
                  { value: 'One Way', label: 'One Way' },
                  { value: 'Round Trip', label: 'Round Trip' },
                ]}
              />
            </div>
          </div>
          <div className="w-full mt-5 md:mt-10">
            <button
              onClick={handleNavigate}
              className="bg-sky-500 px-4 py-1.5 rounded text-xs font-semibold flex items-center gap-2 text-white border-[#5899eb] hover:opacity-80"
            >
              <IoMdSearch size={20} />
              Search Booking
            </button>
          </div>
        </div>
      ) : (
        <div>
          <div className="mt-5 flex gap-4 justify-between items-center">
            <CustomInput
              value={bookingId}
              onChange={(text) => setBookingId(text)}
              placeholderValue={'Booking Id'}
              labelValue={'Booking Id:'}
            />
            <div>
              <SkyButton label={'Search'} onClick={handleNavigate} />
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
